import { render } from "./ReporteGestion.vue?vue&type=template&id=15333118&scoped=true"
import script from "./ReporteGestion.vue?vue&type=script&lang=js"
export * from "./ReporteGestion.vue?vue&type=script&lang=js"

import "./ReporteGestion.vue?vue&type=style&index=0&id=15333118&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15333118"]])

export default __exports__